<template>
  <section class="totales-wrapper-inner">
    <div class="totales-head">
      <div class="totales-icon">
        <v-icon size="16" color="#C8FF4D">{{ icono }}</v-icon>
      </div>
      <h3 class="totales-title">{{ titulo }}</h3>
    </div>

    <div class="totales-grid">
      <div v-for="(item, index) in totales" :key="index" class="stat-card">
        <div class="stat-value">{{ item.total }}</div>
        <div class="stat-label">{{ item.nombre }}</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "CartasTotales",
  props: ["totales", "titulo", "icono", "color"]
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

.totales-wrapper-inner {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;

  font-family: var(--font-body);
  color: var(--text-primary);
}

.totales-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.totales-icon {
  width: 26px;
  height: 26px;
  border-radius: var(--radius);
  background: rgba(200, 255, 77, 0.12);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.totales-title {
  font-family: var(--font-mono);
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin: 0;
}

.totales-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.stat-card {
  background: var(--bg);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 14px 16px;
}

.stat-value {
  font-family: var(--font-display);
  font-size: 19px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: var(--text-secondary);
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/CartasTotales.vue